import React from "react";
import {
  useRetrieveCurrentPlanzone,
  useRetrievePlanzoneSettings,
} from "@planzone/view-models";
import { useUnit } from "@common/unit";

import { Props } from "./types";

function useAllocationUnit(props: Props) {
  const { planzone } = useRetrieveCurrentPlanzone();
  const { settings } = useRetrievePlanzoneSettings(planzone);

  return useUnit({
    ...props,
    unit: `time:${settings.enterTimeAllocationInDays ? "day" : "hour"}`,
  });
}

function AllocationUnit(props: Props) {
  const symbol = useAllocationUnit(props);

  return <>{symbol}</>;
}

export { AllocationUnit, useAllocationUnit };
